import { render, staticRenderFns } from "./editBind.vue?vue&type=template&id=562441f1&scoped=true"
import script from "./editBind.vue?vue&type=script&lang=js"
export * from "./editBind.vue?vue&type=script&lang=js"
import style0 from "./editBind.vue?vue&type=style&index=0&id=562441f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562441f1",
  null
  
)

export default component.exports